import axios from '@utils/axios-client'

export function fetchAllergens (params: any) {
  return axios.get('/api/v1/Allergens', { params }).then(response => response.data)
}
